import { WalletTopup, WalletTopupStatus } from 'modules/organizer/domain/interfaces/wallet-topup';

export interface WalletTopupDto {
  id: number;
  amountInMinorUnits: number;
  qrPayload: string | null;
  status: WalletTopupStatus;
  tbankPaymentId: string | null;
  errorMessage: string | null;
  paidSubscription: { id: number } | null;
}

export function mapWalletTopup(dto: WalletTopupDto): WalletTopup {
  return {
    id: dto.id,
    amountInMinorUnits: dto.amountInMinorUnits,
    qrPayload: dto.qrPayload,
    status: dto.status,
    tbankPaymentId: dto.tbankPaymentId,
    errorMessage: dto.errorMessage,
    paidSubscriptionId: dto.paidSubscription?.id ?? null,
  };
}

export function isWalletTopupTerminal(status: WalletTopupStatus): boolean {
  return status === 'CONFIRMED' || status === 'REJECTED' || status === 'EXPIRED';
}
